export function formatTimeAgo(isoTimestamp: string | undefined): string {
  if (!isoTimestamp) {
    return 'Nunca atualizado'
  }

  try {
    const now = new Date()
    const past = new Date(isoTimestamp)

    if (isNaN(past.getTime())) {
      return 'Data inválida'
    }

    const diffMs = now.getTime() - past.getTime()

    if (diffMs < 0) {
      return formatDateTime(isoTimestamp)
    }

    const diffSeconds = Math.floor(diffMs / 1000)
    const diffMinutes = Math.floor(diffSeconds / 60)
    const diffHours = Math.floor(diffMinutes / 60)
    const diffDays = Math.floor(diffHours / 24)

    if (diffSeconds < 60) {
      return 'Há poucos segundos'
    }

    if (diffMinutes < 60) {
      return diffMinutes === 1 ? 'Há 1 minuto' : `Há ${diffMinutes} minutos`
    }

    if (diffHours < 24) {
      return diffHours === 1 ? 'Há 1 hora' : `Há ${diffHours} horas`
    }

    if (diffDays === 1) {
      return 'Há 1 dia'
    }

    if (diffDays < 7) {
      return `Há ${diffDays} dias`
    }

    return formatDateTime(isoTimestamp)
  } catch (error) {
    console.error('Error formatting time ago:', error)
    return 'Data inválida'
  }
}

export function formatDateTime(isoTimestamp: string): string {
  try {
    const date = new Date(isoTimestamp)

    if (isNaN(date.getTime())) {
      return 'Data inválida'
    }

    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')

    return `${day}/${month}/${year} às ${hours}:${minutes}`
  } catch (error) {
    console.error('Error formatting date time:', error)
    return 'Data inválida'
  }
}
